export default "__VITE_ASSET__CI_L63RA__"